import { ActuatorTypes } from 'src/actuators/user-input/calculations/constants.ts';
import { PATHS } from 'src/actuators/router.tsx';
import { Filter } from 'src/utils/composeFilter.ts';
import { NavigateFunction } from 'react-router/dist/lib/hooks';

export const detectActuatorType = (filter: Filter, navigate: NavigateFunction): ActuatorTypes => {
    switch (true) {
        case filter.Family.includes('Linear'):
            return ActuatorTypes.Linear;
        case filter.Family.includes('Non fail-safe'):
            return ActuatorTypes.NonFailSafe;
        case filter.Family.includes('Fail-safe'):
            return ActuatorTypes.FailSafe;
        case filter.Family.includes('Harsh environmental conditions'):
            return ActuatorTypes.HarshEnvironment;
        case filter.Family.includes('Fast running'):
        case filter.Family.includes('Quick running'):
            return ActuatorTypes.Fast;
        default:
            navigate({
                pathname: PATHS.Home,
            });
    }
    return ActuatorTypes.FailSafe;
};
